import React, { useEffect, useState } from "react";
interface ConnectionRequestMatchedWidgetProps {
  guestDetails?: any;
  userDetails?: any;
  requestedConnectionStatus?: any;
  handleRefetchGuestDetails?: any;
  handleChatModal?: any;
}

const ConnectionRequestMatchedWidget: React.FC<
  ConnectionRequestMatchedWidgetProps
> = ({
  guestDetails,
  userDetails,
  requestedConnectionStatus,
  handleRefetchGuestDetails,
  handleChatModal,
}) => {
  const [yourProfilePhoto, setYourProfilePhoto] = useState("");
  const [connectedProfilePhoto, setConnectedProfilePhoto] = useState("");
  const [connectedUserName, setConnectedUserName] = useState("");
  useEffect(() => {
    if (guestDetails && guestDetails?.profilePhoto) {
      setConnectedProfilePhoto(guestDetails?.profilePhoto);
    }
    if (guestDetails && (guestDetails?.firstName)) {
      setConnectedUserName(
        `${guestDetails?.firstName}`
      );
    }
  }, [guestDetails]);

  useEffect(() => {
    if (userDetails && userDetails?.profilePhoto) {
      setYourProfilePhoto(userDetails?.profilePhoto);
    }
  },[userDetails])
  return (
    <div className="w-full md:w-[98%] lg:w-[98%] connection-matched-list">
      <div className="flex flex-col items-center justify-center min-h-screen p-6">
        <div className="flex space-x-4 mb-6">
          {/* User Image */}
          <div className="w-40 h-56 bg-purple-500 rounded-xl overflow-hidden rotate-[-10deg]">
            <img
              src={yourProfilePhoto}
              alt="User"
              className="w-full h-full object-cover"
            />
          </div>
          {/* Other Image */}
          <div className="w-40 h-56 bg-gray-800 rounded-xl overflow-hidden rotate-[10deg]">
            <img
              src={connectedProfilePhoto}
              alt={connectedUserName}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="p-2 break-words text-xl font-bold text-[#0F090B] font-[PINYADA-Beranda-Regular] tracking-tighterCustom leading-tight-120 tracking-tight-3">
          You and {connectedUserName} Connected!
        </div>

        <div className="flex justify-center items-center w-full ">
          <button
            onClick={() => handleRefetchGuestDetails()}
            className="mt-4 px-6 py-2 bg-white text-black rounded-full shadow-md border border-white hover:bg-gray-100 mx-4"
          >
            Okay
          </button>
          <button
            onClick={() => handleChatModal()}
            className="mt-4 px-6 py-2 bg-white text-black rounded-full shadow-md border border-white hover:bg-gray-100 mx-4"
          >
            Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectionRequestMatchedWidget;
